import { Injectable } from '@angular/core';
import { Wishlist } from '@df/session/api/wishlist/wishlist';
import { Subject } from 'rxjs/internal/Subject';
import { WishlistEvent } from './wishlist.interface';

@Injectable({
    providedIn: 'root'
})
export class WishlistDecorator extends Wishlist {
    change = new Subject<WishlistEvent>();
}
